import React, { useState } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
 import Clear from "./clear"
import SearchBox from "../searchbox"

const renderChevron = isExpanded =>
    isExpanded
        ? <svg><use xlinkHref="#chevron-up" /></svg>
        : <svg><use xlinkHref="#chevron-down" /></svg>

const filterComponentBodyClasses = (withExpander, isExpanded) => classNames({
	"filter-group__body": true,
	"filter-group__body--expander": withExpander,
	"is-expanded": isExpanded,
})

/**
 *  Higher order component that takes a component and wraps it in a
 *  filter-group with extra functionality
 */
 function FilterComponent({
    wrapper,
    heading,
    withExpander,
    withQuery,
    withClear,
    ...otherProps
}) {
   
      const [isExpanded, toggleExpand] = useState( false );

   return (
        <div className="filter-group">
            <div className="filter-group__header" onClick={() => toggleExpand(!isExpanded)}>
                <h3 className="filter-group__heading">{heading} {withClear}</h3>
                 {withClear && <Clear />}
                {withExpander && renderChevron(isExpanded)}
            </div>
        <div className={filterComponentBodyClasses(withExpander, isExpanded)}>
            {withQuery &&
                <SearchBox placeholder="Search here..." />}
           {wrapper}
        </div>
    </div>
    )
}
FilterComponent.propTypes = {
  	heading: PropTypes.string,
	type: PropTypes.string,
	isExpanded: PropTypes.bool,
	toggleExpand: PropTypes.func,
	withExpander: PropTypes.bool,
	items: PropTypes.arrayOf(PropTypes.object),
	refine: PropTypes.func,
};
export default FilterComponent